import { Backdrop, Button, Checkbox, Divider, FormControlLabel, Grid, IconButton, Switch, Typography } from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import * as yup from "yup";
import CustomDataGrid from "../../../../../components/dataTable/customDataGrid";
import CustomTextField from "../../../../../components/utils/input/customTextField";
import Modal from "../../../../../components/utils/modal/modal";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import axios from "axios";
import { Delete, EditNote } from "@mui/icons-material";
import DeletePage from "../../../../../components/utils/deleteModal/deletePage";
import _ from "lodash";
import Loader from "../../../../../components/loader/loader";
import { Helmet } from "react-helmet-async";
import { useStyle } from "./style";

const Loyality = () => {
  const dispatch = useDispatch()
  const classes = useStyle()
  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const [pageCount, setPageCount] = useState(0);
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(true);
  const [data, setData] = useState([])
  const [isEdit, setIsEdit] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)
  const [activeId, setActiveId] = useState(null)
  const [active, setActive] = useState(false)
  const [isLoader, setIsLoader] = useState(false); //loader
  const [isChecked, setIsChecked] = useState(false);
  const validationSchema = yup.object({
    loyaltyAmount : yup.string().required("This field is required field"),
    loyaltyPoints: yup.string().required("This field is required field"),
    redemptionAmount: yup.string().required("This field is required field"),
    redemptionPercentage: yup.string().required("This field is required field"),
    referee_points: yup.string().required("This field is required field"),
    referrer_points: yup.string().required("This field is required field"),
  })
  
  const formik = useFormik({
    initialValues :{
      loyaltyAmount : "",
      loyaltyPoints:"",
      redemptionAmount:"",
      redemptionPercentage:"",
      referrer_points:"",
      referee_points:""
    },
    validationSchema:validationSchema,
    onSubmit: isEdit ? handleUpdate : handleCreate
  })
  const onCreate = () => {
    setOpen(true)
    formik.resetForm()
    setIsEdit(false)
  }
  function handleCreate(){
    const loyalityData = {
      loyalty_amount: formik.values.loyaltyAmount,
      loyalty_points: formik.values.loyaltyPoints,
      redemption_amount:formik.values.redemptionAmount,
      company_id:1,
      redemption_percentage:formik.values.redemptionPercentage,
      referee_points:formik.values.referee_points,
      referrer_points:Number(formik.values.referrer_points)

    }
    setIsLoader(true);
    axios.post('/v1/loyalty', loyalityData)
    .then(res=>{
      console.log(res)
      getUomData()
      setIsLoader(false);
      dispatch(setSnackbar(true, 'success', 'Created Successfully'))
    })
    .catch(err=>{
      dispatch(setSnackbar(true, 'error',err.response.data.errors[0].message))
      console.log(err)
      setIsLoader(false);
    })
  }
  function onEdit(e){
    console.log(e)
    formik.setFieldValue('uom',e.name)
    formik.setFieldValue('uomSName',e.uomSName)
    setIsEdit(true)
    setOpen(true)
    setActive(e.isActive)
    setActiveId(e.id)
    }
    function handleUpdate(){
      const uomData = {
        units_short_name: formik.values.uomSName,
        units_long_name: formik.values.uom,
        company_id:1,
        is_active : active
      }
      setIsLoader(true);
      axios.put(`/v1/units/${activeId}`, uomData)
      .then(res=>{
        setOpen(false)
        console.log(res)
        getUomData()
        setIsLoader(false);
        dispatch(setSnackbar(true, 'success', 'Updated Successfully'))
      })
      .catch(err=>{
        dispatch(setSnackbar(true, 'error',err.response.data.errors[0].message))
        console.log(err)
        setIsLoader(false);
      })
    console.log('update')
    }
    function OnDelete(id){
      setOpenDialog(true)
      setActiveId(id)
    }  
    const handleDelete = () =>{
      setIsLoader(true);
      axios.delete(`/v1/units/${activeId}`)
      .then(res=>{
        setOpenDialog(false)
        getUomData()
        console.log(res)
        dispatch(setSnackbar(true, 'success', 'Deleted Successfully'))
        setIsLoader(false);
        setOpen(false)
      })
      .catch(err=>{
        dispatch(setSnackbar(true, 'error',err.response.data.errors[0].message))
        console.log(err)
        setIsLoader(false);
      })
    console.log('fasdf')
    }
    console.log(isChecked)
    console.log(!isChecked)
    const hanldeSwitch = () => {
      const check = {
        is_verify : !isChecked
      }
      axios.post(`/v1/stock_verify_setting` ,check)
      .then((res) => {console.log(res);setIsChecked(!isChecked)})
      .catch((err) => {console.log(err)})
      
    }
    const getSwitch = () => {
      axios.get(`/v1/stock_verify_setting`)
      .then((res) => {console.log(res)})
      .catch((err) => {console.log(err)})
    }
  const columns = [
    {
      field: "sno",
      headerName: "S.no",
      flex: 1,
      minWidth: 70,
      maxWidth: 100,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "loyalty_amount",
      headerName: "Loyalty Amount",
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "loyalty_points",
      headerName: "Loyalty Points",
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "redemption_amount",
      headerName: "Redemption Amount",
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "redemption_percentage",
      headerName: "Redemption Percentage",
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "referrer_points",
      headerName: "Referre points",
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "referee_points",
      headerName: "Referee points",
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "active",
      headerName: "Status",
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <div className="">
          <Switch checked={params.row.isActive}/>
        </div>
      )
    },
    {
      field: 'action',
      headerName: 'Action',
      flex: 1,
      minWidth: 100,
      headerAlign: "center",
      align: "center",
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <div className='flex justify-center w-full'>
          <IconButton onClick={()=>onEdit(params.row)} >
            <EditNote sx={{color:"#1972d2",fontSize:22}}/>
          </IconButton>
          <IconButton onClick={() => OnDelete(params.id)}>
            <Delete sx={{color:"red",fontSize:22}}/>
          </IconButton>
        </div>
      ),
    },
  ];
  const rows = _.map(data, (val,idx) => ({
    id:idx,
    sno:idx + 1,
    loyalty_amount:val.loyalty_amount,
    loyalty_points:val.loyalty_points,
    isActive:val.is_active,
    redemption_amount:val.redemption_amount,
    redemption_percentage:val.redemption_percentage,
    referrer_points:val.referrer_points,
    referee_points:val.referee_points,

  }))
  const props = {
    rows: rows,
    columns: columns,
    search: search,
    setSearch: setSearch,
    page: page,
    setPage: setPage,
    rowsPerPage: rowsPerPage,
    setRowsPerPage: setRowsPerPage,
    pageCount: pageCount,
    pageOption: pageOption,
  };
  const getUomData = () =>{
    setIsLoader(true);
    // const url = `/v1/units/${rowsPerPage}/${page + 1}`
    // const searchUrl = `/v1/units/${rowsPerPage}/${page + 1}/${search}`
    axios.get(`/v1/loyalty/info/1`)
    .then(res=>{
      console.log(res)
      setData(res.data)
      setActive(res.data.is_active)
     formik.setFieldValue("loyaltyAmount" , res.data.loyalty_amount)
     formik.setFieldValue("loyaltyPoints" , res.data.loyalty_points)
     formik.setFieldValue("redemptionAmount" , res.data.redemption_amount)
     formik.setFieldValue("redemptionPercentage" , res.data.redemption_percentage)
     formik.setFieldValue("referrer_points" , res.data.referrer_points)
     formik.setFieldValue("referee_points" , res.data.referee_points)
      setIsLoader(false);
    })
    .catch(err=>{
      console.log(err)
      setIsLoader(false);
      // dispatch(setSnackbar(true, 'error', err.response.data.error))
    })
  }
  useEffect(()=>{
    getUomData()
    },[rowsPerPage, page, search])
    console.log(data)
    useEffect(()=> {
      getSwitch()
    },[isChecked])
  return (
    <Grid className="">
      <Helmet>
        <title>Settings</title>
      </Helmet>
      <Typography variant="h5">Loyalty</Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4} lg={3}  >
        <CustomTextField id='loyaltyAmount' value={formik.values.loyaltyAmount} title='Loyalty Amount' multiple={false} placeholder='Enter Loyalty Amount' onchange={formik.handleChange} errorMsg={formik.touched.loyaltyAmount && Boolean(formik.errors.loyaltyAmount)} helperText={formik.touched.loyaltyAmount && formik.errors.loyaltyAmount}/>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}  >
        <CustomTextField id='loyaltyPoints' value={formik.values.loyaltyPoints} title='Loyalty Points' multiple={false} placeholder='Enter Loyalty Points' onchange={formik.handleChange} errorMsg={formik.touched.loyaltyPoints && Boolean(formik.errors.loyaltyPoints)} helperText={formik.touched.loyaltyPoints && formik.errors.loyaltyPoints}/>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}  >
        <CustomTextField id='redemptionAmount' value={formik.values.redemptionAmount} title='Redemption Amount (Rs.)' multiple={false} placeholder='Enter Redemption Amount' onchange={formik.handleChange} errorMsg={formik.touched.redemptionAmount && Boolean(formik.errors.redemptionAmount)} helperText={formik.touched.redemptionAmount && formik.errors.redemptionAmount}/>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}  >
        <CustomTextField id='redemptionPercentage' value={formik.values.redemptionPercentage} title='Redemption Percentage (%)' multiple={false} placeholder='Enter Redemption Percentage' onchange={formik.handleChange} errorMsg={formik.touched.redemptionPercentage && Boolean(formik.errors.redemptionPercentage)} helperText={formik.touched.redemptionPercentage && formik.errors.redemptionPercentage}/>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}  >
        <CustomTextField id='referrer_points' value={formik.values.referrer_points} title='Referrer Points' multiple={false} placeholder='Enter Referrer points' onchange={formik.handleChange} errorMsg={formik.touched.referrer_points && Boolean(formik.errors.referrer_points)} helperText={formik.touched.referrer_points && formik.errors.referrer_points}/>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}  >
        <CustomTextField id='referee_points' value={formik.values.referee_points} title='Referee Points' multiple={false} placeholder='Enter Referrer points' onchange={formik.handleChange} errorMsg={formik.touched.referee_points && Boolean(formik.errors.referee_points)} helperText={formik.touched.referee_points && formik.errors.referee_points}/>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} className="flex items-center">
        <FormControlLabel  control={<Checkbox checked={active} onChange={()=>setActive(!active)}/>} label="Active" />
        </Grid>
        
      </Grid>
      <Grid className="flex justify-end">
      <Button variant="contained" onClick={formik.handleSubmit}> Save </Button>
      </Grid>
      <Divider sx={{marginBlock:1}} />
      <Typography variant="h5">Stock Verify Setting</Typography>
        <Grid sx={{display:"flex",alignItems:"center"}}>
        <Typography>Manual</Typography>  <Switch sx={{marginInline:1}} onClick={hanldeSwitch} checked={isChecked}/> <Typography>Auto</Typography>
        </Grid>
     
      <Backdrop open={openDialog} sx={{zIndex:1350}}>
  <DeletePage onCancel={setOpenDialog} onSubmit={handleDelete}/>
</Backdrop>
{/* <Loader isLoader={isLoader} /> */}
    </Grid>
  );
};

export default Loyality;